<div class="modal-header">
    <h4 class="modal-title" id="modal-empresa-title">Detalles de la Empresa</h4>
    <button
        type="button"
        class="btn-close"
        aria-label="Cerrar"
        (click)="activeModal.dismiss('Cierre con X')"></button>
</div>
<div class="modal-body">
    <div *ngIf="isLoading" class="text-center">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
        <p>Cargando información de la empresa...</p>
    </div>

    <div *ngIf="!isLoading && errorMessage" class="alert alert-warning">
        {{ errorMessage }}
    </div>

    <div *ngIf="!isLoading && !errorMessage && empresa">
        <dl class="row">
            <dt class="col-sm-4">NIT:</dt>
            <dd class="col-sm-8">{{ empresa.nit || 'N/A' }}</dd>

            <dt class="col-sm-4">Razon social:</dt>
            <dd class="col-sm-8">{{ empresa.razonSocial || 'N/A' }}</dd>

            <dt class="col-sm-4">Tipo de empresa:</dt>
            <dd class="col-sm-8">{{ empresa.tipoEmpresa || 'N/A' }}</dd>

            <dt class="col-sm-4">Tipo de producto:</dt>
            <dd class="col-sm-8">{{ empresa.tipoProducto || 'N/A' }}</dd>

            <dt class="col-sm-4">Estabón:</dt>
            <dd class="col-sm-8">{{ empresa.eslabon || 'N/A' }}</dd>

            <dt class="col-sm-4">Teléfono:</dt>
            <dd class="col-sm-8">{{ empresa.telefono || 'N/A' }}</dd>

            <dt class="col-sm-4">Correo Electrónico:</dt>
            <dd class="col-sm-8">{{ empresa.correoElectronico || 'N/A' }}</dd>

            <dt class="col-sm-4">Fecha de registro de la empresa:</dt>
            <dd class="col-sm-8">{{ empresa.fechaRegistro || 'N/A' }}</dd>

            <dt class="col-sm-4">
                Responsable de diligenciar la información en Siriiagro:
            </dt>
            <dd class="col-sm-8">
                {{ empresa.responsableInformacion || 'N/A' }}
            </dd>
        </dl>
    </div>
    <div *ngIf="!isLoading && !errorMessage && !empresa">
        <p>No se pudo cargar la información de la empresa.</p>
    </div>
</div>
<div class="modal-footer">
    <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="activeModal.close('Cerrar click')">
        Cerrar
    </button>
</div>
